// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './Homepage/Navbar.css';
import './Homepage/Hero.css';
import './Homepage/ThinkFinance.css';
import './Homepage/ThinkHR.css';
import './Homepage/MarketResearch.css';
import './Homepage/TAAS.css';
import './Homepage/ProductsGrid.css';
import './Homepage/Footer.css';
import Navbar from './Homepage/Navbar';
import Footer from './Homepage/Footer';

// Homepage componentsents
import Home from './Home';
import ThinkFinancePage from './Pages/ThinkFinancePage';
import ThinkHRPage from './Pages/ThinkHRPage';
import MarsPage from './Pages/MarsPage';
import BSCPage from './Pages/BSCPage';
import TAASPage from './Pages/TAASPage';
import Resources1 from './Pages/Resources1';
import Resources2 from './Pages/Resources2';
import TestimonialsPage from './Pages/TestimonialsPage';
import ContactUs from './Pages/ContactUs';

function App() {
  return (
    <Router /*basename="/intematics"*/>
      
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/thinkfinance" element={<ThinkFinancePage />} />
            <Route path="/thinkhr" element={<ThinkHRPage />} />
            <Route path="/marketresearch" element={<MarsPage />} />
            <Route path="/BSC" element={<BSCPage />} />
            <Route path="/DAAS" element={<TAASPage />} />
            <Route path="/usecase_finance" element={<Resources1 />} />
            <Route path="/usecase_hr" element={<Resources2 />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contactus" element={<ContactUs />}/>
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;